import { render, staticRenderFns } from "./PageGoodsCollectDetail.vue?vue&type=template&id=cb47ed06&scoped=true"
import script from "./PageGoodsCollectDetail.vue?vue&type=script&lang=js"
export * from "./PageGoodsCollectDetail.vue?vue&type=script&lang=js"
import style0 from "./PageGoodsCollectDetail.vue?vue&type=style&index=0&id=cb47ed06&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb47ed06",
  null
  
)

export default component.exports